export default {
  init() {
    // JavaScript to be fired on the checkout page

    $(document).ready(function(){
      let searchResultTabSelect = $('.search-results-tabs__tab-header-single');

      searchResultTabSelect.click(function(){
        searchResultTabSelect.removeClass('active');
        $(this).addClass('active');
        let selectedTab = $(this).attr('data-tabClick');
        let singleTab = $('.search-results-tabs__single-tab');
        let chosenTab = $('*[data-tab="' + selectedTab + '"]');
        singleTab.hide();
        chosenTab.show();
      });

      let searchHeaderInputWrapper = $('.search-header__input-wrapper');
      searchHeaderInputWrapper.find('.arrow-icon').click(function(){
        if(searchHeaderInputWrapper.find('input').val() === '') {
          searchHeaderInputWrapper.find('input').attr('placeholder', 'Please enter a search query!');
        } else {
          $(this).parent().submit();
        }
      });

      $('.search-load-more-posts').click(function(){
        let clickedButton = $(this);
        let nextPostNum = parseInt(clickedButton.attr('data-next'));
        let i;
        for (i = nextPostNum; i < (nextPostNum + 5); i++) {
          clickedButton.parent().find("[data-iteration='" + i + "']").slideDown();
        }

        let newNextPostNum = nextPostNum + 5;
        if(!clickedButton.parent().find("[data-iteration='" + newNextPostNum + "']").length) {
          clickedButton.hide();
        }

        clickedButton.attr('data-next', newNextPostNum);
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/search.js